import React from 'react';
import {connect} from 'react-redux';
import {fetchGroomerPlanningForYearAndMonth} from '../../redux/planning/actions';
import {Status} from '../../redux/_commons/const';
import moment from 'moment';
import GroomerPopup from './GroomerPopup';
import JustificationPopup from './JustificationPopup';
import {CSS_NAMES_FOR_JUSTIFICATIONS_ITEMS} from '../../config';
import {Portal} from 'react-portal';


/** Ligne mensuelle de status d'une dameuse */
@connect(
  state => ({
    planning: state.planning,
    user: state.user,
    updates: state.updates
  }),
  {fetchGroomerPlanningForYearAndMonth}
)
export default class MessagesRow extends React.Component {

  constructor() {
    super();
    this.state = {
      showPopup: false,
      displayJustifPopupForDay: -1,
      lastUpdate: 0,
      highlightId: -1
    };
  }

  load(timestamp = +moment.utc()) {
    const {fetchGroomerPlanningForYearAndMonth, groomer, shownDate} = this.props;
    fetchGroomerPlanningForYearAndMonth(groomer,
      moment(shownDate).year(), moment(shownDate).month() + 1);
    this.setState({lastUpdate: timestamp});
  }

  componentDidMount() {
    this.load();
  }

  componentWillReceiveProps({groomer, shownDate, updates}) {
    const p = this.props;
    if (groomer.id !== p.groomer.id || !moment(p.shownDate).isSame(shownDate, 'month')) {
      p.fetchGroomerPlanningForYearAndMonth(groomer,
        moment(shownDate).year(), moment(shownDate).month() + 1);
    }
    if (updates.content.groomers
      && updates.content.groomers[groomer.id] !== undefined
      && updates.content.groomers[groomer.id] !== null) {
      const messages = +moment.utc(updates.content.groomers[groomer.id].messages, 'YYYY-MM-DD HH:mm:SS');
      const justifications = +moment.utc(updates.content.groomers[groomer.id].messages, 'YYYY-MM-DD HH:mm:SS');
      const overallUpdate = Math.max(messages, justifications);
      const {lastUpdate} = this.state;
      if (overallUpdate > lastUpdate) {
        this.load(overallUpdate);
      }
    }
  }

  getOperationalDaysCount() {
    return this.props.groomer.operationalDaysCount;
  }

  render() {
    let {groomer, shownDate, selectedDate} = this.props;
    const {user} = this.props;
    const year = moment(shownDate).year();
    const month = moment(shownDate).month() + 1;
    const selectedDay = moment(selectedDate).date();

    let key = `${groomer.id}.${year}.${month}`;
    let planning = this.props.planning.get(key);
    let content = <div>...</div>;

    if (planning && planning === Status.FAILURE) {
      content = <div>Une erreur a eu lieu</div>;
    } else if (planning && planning !== Status.LOADING) {
      content = <div className="groomer-monthly-status">
        {planning.map(({messages, justification, date}, i) =>
          <DayTile
            onMouseOver={() => this.setState({highlightId: i})}
            onMouseOut={() => this.setState({highlightId: -1})}
            highlighted={i === this.state.highlightId}
            key={i}
            openingDate={ user.selectedSkiresort.openingDate }
            closingDate={ user.selectedSkiresort.closingDate }
            date={ date }
            content={ messages[0] || justification }
            messages={messages}
            onClick={ () => !user.infos.is_admin ? null : this.setState({displayJustifPopupForDay: i}) }
          />
        )}
        <div className="clearfix"></div>
      </div>;
    }

    let currentMessage, currentStatus, currentTitle, currentJustification;

    if (!moment(selectedDate).isSame(shownDate, 'month')) {
      currentMessage = '';
    } else if (!planning || planning === Status.FAILURE || planning === Status.LOADING ) {
      currentMessage = currentStatus = '...';
    } else if (planning.get(selectedDay - 1).messages.length > 0) {
      const msg = planning.get(selectedDay - 1).messages[0];
      currentMessage = msg.details || msg.message;
      if (msg.beacon) {
        currentMessage += ' (' + msg.beacon + ') ';
      }
      currentStatus = msg.type;
      currentJustification = msg.justification;
      currentTitle = msg.datetimeReceived + '\n' + currentMessage;
    } else if (planning.get(selectedDay - 1).justification) {
      const justif = planning.get(selectedDay - 1).justification;
      currentMessage = justif.message;
      currentStatus = 'JUSTIFICATION';
      currentTitle = justif.datetime + '\n' + currentMessage;
    } else {
      currentMessage = 'Non activé, confirmer l\'état';
      currentStatus = 'MISSING';
    }

    return (
      <div className="planning-row">
        {this.state.displayJustifPopupForDay !== -1 ?
          <JustificationPopup
            selectedDay={this.state.displayJustifPopupForDay + 1}
            onClose={() => this.setState({displayJustifPopupForDay: -1})}
            groomer={groomer}
            year={year}
            month={month}
            day={this.state.displayJustifPopupForDay}
            idx={this.props.idx}/>
          : null
        }
        {this.state.showPopup ? <GroomerPopup groomer={groomer} idx={this.props.idx}/> : null}
        {/*<span className="groomer-opdayscount">{this.getOperationalDaysCount()}</span>*/}
        <GroomerMessage title={currentTitle} status={currentStatus} message={currentMessage} justification={currentJustification}/>
        <span className="groomer-code"
              onMouseOver={() => this.setState({showPopup: true})}
              onMouseOut={() => this.setState({showPopup: false})}
        ><span>{groomer.code}</span></span>
        <span className="groomer-model"
              onMouseOver={() => this.setState({showPopup: true})}
              onMouseOut={() => this.setState({showPopup: false})}
        >{groomer.model}</span>
        {content}
      </div>
    );
  }
}

/** Etat journalier d'une dameuse */
class DayTile extends React.Component {

  constructor() {
    super()
    this.state = {
      position: {
        top: 0,
        left: 0
      },
      node: null
    }
  }

  render() {
    const {openingDate, closingDate, date, content, onClick, messages, onMouseOver, onMouseOut, highlighted} = this.props

    let classes = ['day', 'groomer-status-bg'];
    let canBeJustified = false;
    let tileContent = null;

    if (!moment(date).isBetween(openingDate, closingDate)) {
      classes.push('OUT-OF-SEASON');
    } else if (moment(date).isAfter()) {
      classes.push('FUTURE');
    } else if (!content) {
      classes.push('MISSING');
      canBeJustified = true;
    } else if (!content.type) {
      classes.push('JUSTIFICATION');
      classes.push(CSS_NAMES_FOR_JUSTIFICATIONS_ITEMS[content.message]);
      canBeJustified = true;
    } else if (content.type === 'ALERT' && content.justification !== '' && content.justification !== null && content.justification !== undefined) {
      classes.push('ALERT');
      classes.push('justified');
    } else if (content.type === 'MAINTENANCE' && content.justification !== '' && content.justification !== null && content.justification !== undefined) {
      classes.push('MAINTENANCE');
      classes.push('justified');
    }
    else {
      classes.push(content.type);
    }

    if (messages && messages.length > 1) {
      classes.push('groomer-status-multiple');
      var msgElts= messages.map((msg, i) => {
        let m = msg.details || msg.message;
        if (msg.beacon) {
          m += ' (' + msg.beacon + ') ';
        }
        let s = msg.type;
        let t = msg.datetimeReceived + '\n' + m;

        return <GroomerMessage title={t} status={s} message={m} justification={msg.justification} key={msg.id}/>;
      });

      var contClasses = ['more-messages']
      if (highlighted) {
        contClasses.push('hover')
      }
      tileContent = (
        <Portal>
          <div className={contClasses.join(' ')} style={this.state.position} onMouseOver={ onMouseOver } onMouseOut={ onMouseOut }>
            {msgElts}
          </div>
        </Portal>
      );
    }

    return (
      <div
        ref={ (node) => { this.node = node; } }
        onClick={ canBeJustified ? onClick : null }
        onMouseOver={ onMouseOver }
        onMouseOut={ onMouseOut }
        className={ classes.join(' ') }>
        { tileContent }
      </div>
    );
  }

  componentDidMount() {
    const {top, left} = this.node.getBoundingClientRect()
    this.setState({
      position: {
        top, left
      }
    })
  }
}


let GroomerMessage = ({title, status, message, justification}) => {
  let isJustified = justification !== "" && justification !== null && justification !== undefined;
  return(<div className="groomer-message" title={title}>
    <div className={`groomer-status-bg ${status} ${CSS_NAMES_FOR_JUSTIFICATIONS_ITEMS[message]} ${isJustified ? 'justified': null}`}/>
    <span>{message} { isJustified ? <i className="mi mi-done green" />: null} </span>
  </div>);
};



// WEBPACK FOOTER //
// ./src/components/SupportMessages/MessagesRow.js